import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {BaseFormGroup} from '../../../shared/utils/base-form-group';
import {PaymentConfigModel} from '../../../../api/model/Payment.config.model';
import {DropdownModel} from '../../../../api/model/shared/dropdown.model';
import {PaymentItemType} from '../../models/payment-type';
import {NotificationService} from '../../../../core/services/notification.service';

@Component({
  selector: 'tj-payment-details-form',
  templateUrl: './payment-details-form.component.html',
  styleUrls: ['./payment-details-form.component.scss'],
})
export class PaymentDetailsFormComponent extends BaseFormGroup implements OnInit, OnDestroy {
  @Input() paymentConfig: PaymentConfigModel;
  @Input() itemType: PaymentItemType;
  @Input() form: UntypedFormGroup;
  @Input() paymentDetails: any;
  @Output() formValid = new EventEmitter<any>();
  @Output() nextStep = new EventEmitter<void>();

  itemTypes: DropdownModel[] = [
    {label: 'Ticket', value: PaymentItemType.TICKET},
    {label: 'Invoice', value: PaymentItemType.INVOICE},
  ];

  private validationTimeout: any;

  // Form control getters
  get fcNetAmount() {
    return this.form.get('netAmount');
  }
  get fcApplyTax() {
    return this.form.get('applyTax');
  }
  get fcTaxRate() {
    return this.form.get('taxRate');
  }
  get fcApplyCCFee() {
    return this.form.get('applyCCFee');
  }
  get fcCCFeeRate() {
    return this.form.get('ccFeeRate');
  }
  get fcNetTerm() {
    return this.form.get('itemType');
  }
  get fcInvoice() {
    return this.form.get('invoiceId');
  }
  get fcDescription() {
    return this.form.get('description');
  }
  get fcCustomerName() {
    return this.form.get('customerName');
  }
  get fcEmail() {
    return this.form.get('email');
  }
  get fcAddress() {
    return this.form.get('address');
  }

  constructor(private fb: UntypedFormBuilder, private notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    this.currentFormGroup = this.form;
    this.defineGetters(this.form.controls);
  }

  onNext() {
    // Mark all form fields as touched to show validation errors
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control.markAsTouched();
    });
    
    // Check if the form is valid (this will include the min validation)
    if (!this.form.valid) {
      // Show error message for invalid form
      this.notificationService.error('Please fill in all required fields');
      return;
    }
    
    this.formValid.emit({form: this.form, paymentDetails: this.paymentDetails});
    this.nextStep.emit();
  }

  // Mark field as touched when user starts typing to show validation errors
  onNetAmountChange() {
    // Clear any existing timeout
    if (this.validationTimeout) {
      clearTimeout(this.validationTimeout);
    }
    
    // Set a timeout to show validation errors after user stops typing
    this.validationTimeout = setTimeout(() => {
      if (this.fcNetAmount.invalid) {
        this.fcNetAmount.markAsTouched();
      }
    }, 500); // Wait 500ms after user stops typing
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    // Cleanup the timeout when the component is destroyed
    if (this.validationTimeout) {
      clearTimeout(this.validationTimeout);
    }
  }
}
